import QuerySettings from "graphql/queries/QuerySettings";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchSettings {
	
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'settings', QuerySettings, {
			//instant: true,
			resultPath: [ 'settings' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
}
